import { Injectable } from '@angular/core';
import { urls } from './../../../../../environments/environment';
import { HttpClient } from '@angular/common/http';

@Injectable()
export class CriarSenhaService {

  constructor(private http: HttpClient ) { }

  criarSenha(data) {
    return this.http
      .put(`${urls.apiBaseActuar}/Contas/CriarSenha`, data);
  }
}
